import React, { useState } from "react";
import { Col_12_8_6_4 } from "../../../../components/col/Col_12_8_6_4";
import LabelValor from "../../../../components/label/LabelValor";
import { Modal, Input } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { startUpdateServicio } from "../../../../context/actions/concesionariosActions";

export const AsesorServiciosGruas = () => {
  const [newValor, setNewValor] = useState("");
  const { id } = useParams();
  const dispatch = useDispatch();

  const { concesionariosServicio: c } = useSelector(
    (state) => state.concesionariosReducer
  );

  const [openModal, setOpenModal] = useState(false);

  const handleOpen = () => {
    setNewValor(c?.asesorServiciosGruas || "");
    setOpenModal(true);
  };

  const handleOk = () => {
    dispatch(startUpdateServicio({ asesorServiciosGruas: newValor }, id));
    setOpenModal(false);
  };

  return (
    <>
      <Col_12_8_6_4>
        <LabelValor
          labelStyle={{ cursor: "pointer", textDecoration: "underline dotted" }}
          onClick={handleOpen}
          label="Asesor de servicios grúas"
          valor={c?.asesorServiciosGruas ? c.asesorServiciosGruas.charAt(0).toUpperCase() + c.asesorServiciosGruas.slice(1) : ""}
        />
      </Col_12_8_6_4>
      <Modal
        title="Asesor de servicios grúas"
        onCancel={() => setOpenModal(false)}
        onOk={handleOk}
        open={openModal}
      >
        <Input
          value={newValor}
          onChange={(e) => setNewValor(e.target.value)}
          placeholder="Ingrese asesor de servicios de grúas"
          style={{ width: "100%" }}
        />
      </Modal>
    </>
  );
};
